export default "__VITE_ASSET__CmckRpy5__"